var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveVessel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vessel",
    clipPath: "url(#clip0_3598_49045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94836 9.6221L4 11.5429V9C4 7.93913 4.42143 6.92172 5.17157 6.17157C5.92172 5.42143 6.93913 5 8 5V4C8 2.93913 8.42143 1.92172 9.17157 1.17157C9.92172 0.421427 10.9391 0 12 0C13.0609 0 14.0783 0.421427 14.8284 1.17157C15.5786 1.92172 16 2.93913 16 4V5C17.0609 5 18.0783 5.42143 18.8284 6.17157C19.5786 6.92172 20 7.93913 20 9V11.543L14.0515 9.6221L12.9739 9.26096C12.658 9.1551 12.3289 9.10327 11.9999 9.10554C11.671 9.10327 11.3418 9.1551 11.0259 9.26096L9.94836 9.6221Z",
    fill: "#1F8475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2929 20.2929C22.4804 20.1054 22.7348 20 23 20C23.2652 20 23.5196 20.1054 23.7071 20.2929C23.8946 20.4804 24 20.7348 24 21C24 22.626 22.282 24 20.246 24C19.2406 24.0054 18.2665 23.6507 17.5 23C16.7281 23.6417 15.7567 23.9943 14.7529 23.9972C14.1451 23.999 13.5484 23.8725 13 23.6309V11.3842L21.9867 14.2862C21.9956 14.505 21.9806 14.7256 21.941 14.944C21.5126 17.268 20.4158 19.4167 18.785 21.127C18.7388 21.1858 18.6961 21.2472 18.657 21.311C18.8548 21.5368 19.1003 21.7158 19.3759 21.835C19.6514 21.9542 19.95 22.0105 20.25 22C21.318 22 22 21.344 22 21C22 20.7348 22.1054 20.4804 22.2929 20.2929Z",
    fill: "#1F8475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.3842L10.5734 11.5219L10.5341 11.5351L1.98149 14.2964C1.97357 14.5119 1.98885 14.729 2.028 14.944C2.46716 17.2708 3.5746 19.4193 5.215 21.127C5.26299 21.1873 5.3074 21.2505 5.348 21.316C5.15004 21.5426 4.90361 21.7218 4.62698 21.8402C4.35035 21.9586 4.05062 22.0132 3.75 22C2.661 22 2 21.306 2 21C2 20.7348 1.89464 20.4804 1.70711 20.2929C1.51957 20.1054 1.26522 20 1 20C0.734784 20 0.48043 20.1054 0.292893 20.2929C0.105357 20.4804 0 20.7348 0 21C0 22.626 1.718 24 3.75 24C4.76118 24.0091 5.7419 23.6542 6.513 23C7.2821 23.6423 8.25158 23.9955 9.25361 23.9984C9.85927 24.0002 10.4538 23.8739 11 23.6329V11.3842Z",
    fill: "#1F8475"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3598_49045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveVessel);
export default __webpack_public_path__ + "static/media/RemoveVessel.adbc4b62cae10e5f11c24377f835c5c0.svg";
export { ForwardRef as ReactComponent };